import { NOTIFICATION_SHOW_START } from './notification.actions';

const defaultState = {
  toast: null,
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case NOTIFICATION_SHOW_START:
      return {
        ...state,
        toast: action.payload.toast,
      };

    default:
      return state;
  }
};
